import {isEnglish} from '../../services/format-datepicker';

/** Oberflaechensprache des Profilers — nicht die gesprochenen Sprachen eines Beraters. */
export type ProfilerLanguage = 'de' | 'en';

export const PROFILER_LANGUAGES: readonly ProfilerLanguage[] = ['de', 'en'];

export const DEFAULT_PROFILER_LANGUAGE: ProfilerLanguage = 'de';

export const PROFILER_LANGUAGE_LABEL_KEYS: Readonly<Record<ProfilerLanguage, string>> = {
  de: 'profilerLanguage.de',
  en: 'profilerLanguage.en',
};

/**
 * Die Profiler-Sprache eines Beraters — `null`, wenn kein `langKey` geliefert wird:
 * dann hat der Berater kein Benutzerkonto und benutzt den Profiler nicht.
 *
 * Sonst dieselbe Regel wie fuer die Anzeigesprache der Anwendung: was dort als
 * Englisch gilt, ist auch hier Englisch, alles Uebrige Deutsch.
 */
export function toProfilerLanguage(
  langKey: string | null | undefined
): ProfilerLanguage | null {
  if (!langKey?.trim()) return null;
  return isEnglish(langKey) ? 'en' : DEFAULT_PROFILER_LANGUAGE;
}

/** Der Uebersetzungsschluessel zur Sprache — leer, wo es keine gibt. */
export function profilerLanguageLabelKey(language: ProfilerLanguage | null): string {
  return language ? PROFILER_LANGUAGE_LABEL_KEYS[language] : '';
}
